var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2449 0.909484C11.8472 1.4783 11.8743 2.42766 11.3055 3.02994L3.77818 11L11.3055 18.9701C11.8743 19.5723 11.8472 20.5217 11.2449 21.0905C10.6426 21.6593 9.69324 21.6322 9.12442 21.0299L0.754117 12.1673C0.135351 11.5121 0.135342 10.4879 0.754116 9.83274L9.12442 0.970069C9.69324 0.367791 10.6426 0.340667 11.2449 0.909484Z",
    fill: "#62646E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.0488ddfc0c02f9b8fbc18351a0f15f13.svg";
export { ForwardRef as ReactComponent };